import { getKeyboardFocusableElements } from '../utils';

class Collapse {
	constructor(el) {
		this.el = el;
		this.content = el.querySelector('[data-collapse-content]');
		this.openButton = el.querySelector('[data-collapse-open]');
		this.closeButton = el.querySelector('[data-collapse-close]');
		this.toggleButton = el.querySelector('[data-collapse-toggle]');

		this.openButton?.addEventListener('click', (e) => {
			this.open();
		});

		this.closeButton?.addEventListener('click', (e) => {
			this.close();
		});

		this.toggleButton?.addEventListener('click', (e) => {
			this.isOpen ? this.close() : this.open();
		});

		if (!this.isOpen) {
			getKeyboardFocusableElements(this.content).forEach((element) => (element.tabIndex = -1));
		} else {
			this.open();
		}
	}


	get isOpen() {
		return this.el.classList.contains('is-open');
	}


	open() {
		this.el.classList.add('is-open');
		this.content.style.height = this.content.scrollHeight + 'px';
		this.content.style.opacity = '1';
		this.openButton?.setAttribute('aria-expanded', true);
		this.closeButton?.setAttribute('aria-expanded', true);
		this.toggleButton?.setAttribute('aria-expanded', true);
		this.el.dispatchEvent(new CustomEvent('collapse-opened', { detail: { el: this.el }, bubbles: true }));

		getKeyboardFocusableElements(this.content).forEach((element) => element.removeAttribute('tabindex'));
	}


	close(instantly = false) {
		this.el.classList.remove('is-open');
		this.content.style.height = '0';
		this.content.style.opacity = '0';
		this.openButton?.setAttribute('aria-expanded', false);
		this.closeButton?.setAttribute('aria-expanded', false);
		this.toggleButton?.setAttribute('aria-expanded', false);
		this.el.dispatchEvent(new CustomEvent('collapse-closed', { detail: { el: this.el }, bubbles: true }));

		getKeyboardFocusableElements(this.content).forEach((element) => (element.tabIndex = -1));
	}
}

export default class Collapses {
	constructor() {
		document.addEventListener('bless', (e) => {
			this.container = e.detail.element;
			this.init(this.container);
		});
	}

	init(container) {
		container.querySelectorAll('[data-collapse]').forEach((element) => {
			new Collapse(element);
		});
	}
}